import React from 'react';
import { connect } from 'react-redux';
import { Collapse, Modal } from 'reactstrap';
import { IAction, IAppState } from '../../../models/action/core';
import * as IFrameActions from '../../../store/actions/iFrameSource';
import CustomIframe from '../../iframe/iframe';
import ReactGA from 'react-ga4';
import Translator from '../../../core/i18n';
import { Common } from '../../../core/common';
import Paginate from '../../table/paginate';
import { SelectAsync } from '../../input/select/main';
import { Log } from 'ng2-logger';
import NotFound from '../../not-found/not-found';


const T = Translator.create();
const _logger = Log.create('Lesson Grade Chart');

let _common: Common;
interface IGradeChartProps {
    classId: string;
    isOpen: boolean;
    onToggle: () => void;
    iFrameSource?: string;
    dispatch: (action: IAction) => void;
}
interface IgradeChartState {
    query: '',
    isSearchBoxOpen: boolean,
    isCreateGradeChartModalOpen: boolean;
    addedActivities: Array<{ name: string; icon: string }>;
    weights: number[];
}
interface ActivitiyInfo {
    name: string;
}
export class CGradeChart extends React.Component<IGradeChartProps, IgradeChartState> {
    activities: ActivitiyInfo[];
    constructor(props: any) {
        super(props);
        _common = new Common();
        this.addNewGradeModal = this.addNewGradeModal.bind(this);
        this.setCloseGradeModal = this.setCloseGradeModal.bind(this);
        this.state = {
            isCreateGradeChartModalOpen: false,
            query: '',
            isSearchBoxOpen: false,
            addedActivities: [],
            weights: [] as number[],
        }
        this.activities = [{ name: 'Assignment' }, { name: 'Exam' }, { name: 'Other' }];
    }

    handleWeightChange(index: number, value: number) {
        this.setState(prevState => {
            const newWeights = [...prevState.weights];
            newWeights[index] = value;

            return { weights: newWeights };
        });
    }

    getTotalWeight() {
        return this.state.weights.reduce((sum, weight) => sum + (weight || 0), 0);
    }

    addActivityCard(activity: { name: string; icon: string }) {
        this.setState(prevState => ({
            addedActivities: [...prevState.addedActivities, activity],
        }));
    }
    removeActivityCard(index: number) {
        this.setState(prevState => ({
            addedActivities: prevState.addedActivities.filter((_, i) => i !== index),
        }));
    }

    public addNewGradeModal() {
        this.setState({ isCreateGradeChartModalOpen: true });
    }

    public setCloseGradeModal() {
        this.setState({ isCreateGradeChartModalOpen: false });
    }
    componentDidMount(): void {
        let model = {
            ClassId: this.props.classId,
            ReturnUrl: '/GradebookItem/Index/{1}'
        }
        this.props.dispatch(IFrameActions.getIFrameSource(model));
    }
    componentDidUpdate(prevProps: IGradeChartProps) {
        if (this.props.isOpen && !prevProps.isOpen) {
            let model = {
                ClassId: this.props.classId,
                ReturnUrl: '/GradebookItem/Index/{1}'
            }
            this.props.dispatch(IFrameActions.getIFrameSource(model));
        }
    }

    onclickDiv = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_CREATE_GRAD_CHART_CLICKED',
            label: 'G_CREATE_GRAD_CHART_CLICKED',
            nonInteraction: true,
        });
        // this.props.onToggle();
    }
    onClickSearchBox = () => {

        let searchBoxValue = true;

        if (this.state.isSearchBoxOpen === true) {
            searchBoxValue = false;
        }

        this.setState({ isSearchBoxOpen: searchBoxValue });
    }

    public render() {

        // Note: This section will be removed once the backend for Grade Chart Creation is completed.
        return (
            <CustomIframe
                id='preview'
                name='preview'
                width={'100%'}
                height={'100%'}
                src={this.props.iFrameSource}
            />
        );
        //////////
        
        return (
            <>
                <Collapse isOpen={this.props.isOpen}>
                    <div style={{ maxWidth: 'calc(100vw - 60px)' }} className="container-fluid">
                        <div className="row ">
                            <div className="col-12 grid-4 gap-2">
                                <button className={`assignment-grade-info totalStudent  w-100`}>
                                    <div className="media-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className='mt-1'>123</h4>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{T.t('r_total_participants')}</span>
                                        </div>
                                    </div>
                                </button>

                                <button className={`assignment-grade-info totalStudent  w-100 `}>
                                    <div className="media-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className='mt-1'>76</h4>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{T.t('r_avarage_grade')}</span>
                                        </div>
                                    </div>
                                </button>
                                <button className={`assignment-grade-info totalStudent  w-100`}>
                                    <div className="media-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className='mt-1'>99</h4>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{T.t('r_highest_grade')}</span>
                                        </div>
                                    </div>
                                </button>
                                <button className={`assignment-grade-info totalStudent  w-100`}>
                                    <div className="media-body">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h4 className='mt-1'>22</h4>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center'>
                                            <span>{T.t('r_lowest_grade')}</span>
                                        </div>
                                    </div>
                                </button>



                            </div>
                            <div className="col-12 d-flex justify-content-between mt-4">
                                <div>
                                    <button className='ml-2 category-tag-square tag-green  '>{T.t('r_edit_grade_chart')}</button>
                                    <button className='ml-2 category-tag-square tag-blue bg-primary text-light  '>{T.t('r_remove_grade_chart')}</button>
                                </div>
                                <div className="lead-search-bar">
                                    <div className="question-filter p-0">
                                        <div className="options">
                                            <button
                                                className="ml-3 mr-3"
                                                onClick={() => this.onClickSearchBox()}

                                                style={{ display: this.state.isSearchBoxOpen ? 'none' : 'block', border: 'none', background: 'none' }}
                                            >
                                                <i className="material-icons mr-2 align-middle">search</i>
                                                {T.t('r_gen_search')}
                                            </button>
                                        </div>
                                        <div
                                            id="assignment-search"
                                            className={this.state.isSearchBoxOpen ? 'search collapse show' : 'search collapse'}
                                            style={{ position: 'inherit' }}
                                        >
                                            <div className="input-group">
                                                <div
                                                    data-toggle="collapse"
                                                    className="input-group-prepend collapsed"
                                                    aria-expanded="false"
                                                >
                                                    <div
                                                        className="input-group-text"
                                                        onClick={() => {
                                                            this.setState({
                                                                ...this.state,
                                                                query: '',
                                                                isSearchBoxOpen: !this.state.isSearchBoxOpen
                                                            });
                                                        }}
                                                    >
                                                        <i className="material-icons">close</i>
                                                    </div>
                                                </div>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="inlineFormInputGroup"
                                                    placeholder={T.t('r_gen_search')}
                                                    value={this.state.query}
                                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                                        const regExp = new RegExp(event.target.value, 'i');

                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* tablo kısmı */}
                            <div className="col-12 d-flex justify-content-end grade-filter-margin" >


                            </div>

                            <div className="col-12">
                                <div style={{ maxWidth: 'calc(95vw - 30px) !important' }} className="table-responsive" >
                                    <table className="table grade-table">
                                        <thead>
                                            <tr>
                                                <th >Katılımcılar</th>
                                                <th>Genel Not</th>
                                                <th className="activity-col">
                                                    <div>
                                                        <img src={_common.GetActivityTypeIcons('default')} alt="" />
                                                        <span>Değerlendirme</span>
                                                    </div>
                                                </th>
                                                <th className="activity-col">
                                                    <div>
                                                        <img src={_common.GetActivityTypeIcons('assignment')} alt="" />
                                                        <span>Ödev Aktivitesi</span>
                                                    </div>
                                                </th>
                                                <th className="activity-col">
                                                    <div>
                                                        <img src={_common.GetActivityTypeIcons('exam')} alt="" />
                                                        <span>Sınav Aktivitesi</span>
                                                    </div>
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* ilk satırda genel ağırlıklandırma ve aktivitelerin ağırlakdırması olaacak */}
                                            <tr>
                                                <td></td>
                                                <td className='text-center activity-col-grade'><i><span>100</span></i></td>
                                                <td className='text-center activity-col-grade'><i><span>20%</span></i></td>
                                                <td className='text-center activity-col-grade'><i><span>30%</span></i></td>
                                                <td className='text-center activity-col-grade'><i><span>50%</span></i></td>
                                            </tr>
                                            <tr>
                                                <td className='activity-col-grade'><span><i>3 Katılımcı</i></span></td>
                                                <td></td>
                                                <td className='activity-col-grade'><span>4 Not | 0 Yayınlandı</span></td>
                                                <td className='activity-col-grade'><span>4 Not | 4 Yayınlandı</span></td>
                                                <td className='activity-col-grade done'><i className="material-icons">check_circle</i>Tamamlandı</td>
                                            </tr>
                                            <tr>
                                                <td className='grade-table-user'>
                                                    <img src={_common.GetDefaultImages('_avatar')} alt="" />
                                                    <span>Ahmet Selim Ergin</span>
                                                </td>
                                                <td>
                                                    <span className="grade-point">
                                                        <span className="grade-point-text success mt-0">95</span>
                                                    </span>
                                                </td>
                                                <td className='activity-col-grade '><div className="new"><a href="#">Not ver</a><span >Yeni Başvuru</span></div></td>
                                                <td className='activity-col-grade '><div className="new"><a href="#" className='disabled'>Not ver</a></div></td>
                                                <td className='activity-col-grade'><span>40</span>Yayınlandı</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                                <Paginate
                                    class={'custom-paginate bg-none-pagniate'}
                                    onPageChange={function (page: number): void {
                                        throw new Error('Function not implemented.');
                                    }
                                    } />
                            </div>


                            {/* not çizelgesi oluşturulmamış ise */}
                            <div className="col-12 mt-4 d-flex flex-column align-items-center grade-info">
                                <NotFound message={T.t('r_not_grade_chart')} type='noData'></NotFound>
                                <button onClick={this.addNewGradeModal.bind(this)} className='ml-2 category-tag-square tag-green  '>{T.t('r_create_grade_chart')}</button>
                            </div>
                        </div>
                    </div>
                </Collapse>

                <Modal
                    isOpen={this.state.isCreateGradeChartModalOpen}
                    toggle={this.setCloseGradeModal}
                    modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                    fade={true}
                    style={{ display: 'block', animationDuration: '0.5s' }}
                    backdrop={"static"}
                    id={'add_new_activity'}
                >
                    <div className="modal-dialog" style={{ width: '50vw', height: window.innerHeight }}>
                        <div className="modal-content" style={{ height: window.innerHeight }}>
                            <div className="modal-header d-flex justify-content-start">

                                <h5 className="modal-title d-flex align-items-center">
                                    <i className="material-icons mr-2">toc</i>
                                    {T.t('r_activity_creating_a_grade_chart')}
                                </h5>
                                <button
                                    onClick={this.setCloseGradeModal}
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-label="Close"
                                >
                                    <i style={{ color: '#000' }} className="material-icons">
                                        close
                                    </i>
                                    <span>{T.t('r_gen_close')}</span>
                                </button>
                            </div>
                            <div className="modal-body p-3" style={{ overflowY: 'auto' }} >
                                <div className="row mt-0">
                                    <div className="col-12 d-flex justify-content-center gap-1">
                                        {this.activities.map(activity => {
                                            return (
                                                <div className="add_activity_list_btn_grid d-flex flex-column align-items-center gap-1" style={{ minWidth: 120 }} key={activity.name}>
                                                    <a
                                                        className="activity_grid_item gap-1"
                                                    >
                                                        <img
                                                            className="mx-2"
                                                            style={{ width: '2em', height: '2em' }}
                                                            src={_common.GetActivityTypeIcons(activity.name)}
                                                            alt={'Activity Icon'}
                                                        />
                                                        <span>{T.t('r_gen_enum_activity_' + activity.name)}</span>
                                                    </a>
                                                    <button type='button' onClick={() =>
                                                        this.addActivityCard({
                                                            name: activity.name,
                                                            icon: _common.GetActivityTypeIcons(activity.name),
                                                        })
                                                    } className=' category-tag-square tag-green  '>{T.t('r_new_add')}</button>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <div className="col-12">
                                        <hr />
                                    </div>

                                    {/* Eklenen Kartlar */}
                                    {this.state.addedActivities.length > 0 ? (
                                        this.state.addedActivities.map((activity, index) => (
                                            <div className="col-12 mb-2" key={index}>
                                                <div className="card d-flex flex-row justify-content-between align-items-center p-3">
                                                    <div className='d-flex gap-1 align-items-center'>
                                                        <div className="d-flex align-items-center flex-column" style={{ minWidth: 100 }}>
                                                            <img
                                                                className="mx-2"
                                                                style={{ width: '24px', height: '24px' }}
                                                                src={activity.icon}
                                                                alt="Activity Icon"
                                                            />
                                                            <span>{T.t('r_gen_enum_activity_' + activity.name)}</span>
                                                        </div>

                                                        <div className="form-input form-group date-picker" style={{ minWidth: 200 }}>
                                                            <SelectAsync
                                                                isMulti={true}
                                                                isSearchable={true}
                                                                placeHolder={T.t('r_gen_activity_name')}
                                                                closeMenuOnScroll={false}
                                                                closeMenuOnSelect={false}
                                                                name={'keywordIds'}
                                                                value={''}
                                                                hasLocalization={true}
                                                                setFieldOnlyValue={true}
                                                                requestType={'get'}
                                                                url={null}
                                                            />
                                                        </div>

                                                    </div>
                                                    {/* Kaldırma Butonu */}
                                                    <div className='d-flex gap-1 align-items-center'>

                                                        <div className="form-input form-group date-picker" style={{ minWidth: 100 }}>
                                                            <input type="number" className='input grade-input' placeholder={T.t('r_weighting')} onChange={(e) => this.handleWeightChange(index, Number(e.target.value))} />
                                                        </div>

                                                        <button
                                                            type="button"
                                                            className="row_delete_btn border-0"
                                                            onClick={() => this.removeActivityCard(index)}
                                                        >
                                                            <i className="material-icons">close</i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        // değerlendirme yoksa
                                        <div className="col-12 text-center mt-3">
                                            <NotFound message={T.t("r_grade_not_found")} subtext={T.t("r_grade_how_create")} />
                                        </div>
                                    )}

                                    {/* toplam ağırlık kısmı */}
                                    {this.state.addedActivities.length > 0 &&
                                        <div className="col-12">
                                            <div className=" ml-auto mt-2" style={{ width: 'fit-content' }}>
                                                <div className="form-input form-group date-picker" style={{ minWidth: 100 }}>
                                                    <input type="number" className='input grade-input' readOnly value={this.getTotalWeight()} />
                                                </div>
                                                <span className={`${this.getTotalWeight() !== 100 ? 'text-danger f13' : 'text-success f13'}`}>{this.getTotalWeight() !== 100 ? T.t("r_min_grade_value") : T.t("r_min_grade_100")}</span>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className="modal-footer d-block">
                                <div className="row">
                                    <div className="col-md">
                                        <button onClick={this.setCloseGradeModal} type='button' className='btn btn-gray ml-2 mobile-activity-regulation-btn'>{T.t('r_cancel_button')}</button>
                                    </div>
                                    <div className="col-md text-md-right">
                                        <button type='button' className='btn btn-success ml-2'>{T.t('r_save_button')}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState, ownProps: any): any => {
    if (!state) {
        return ownProps;
    }

    const newProps: any = Object.assign({}, ownProps, {
        iFrameSource: state.iFrame.iFrameSource
    });
    return newProps;
};

const dispatchProps = (dispatch: (action: IAction) => void) => {
    return {
        dispatch
    };
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return next.iFrame.iFrameSource === prev.iFrame.iFrameSource;
};

const GradeChart = connect(
    mapStateToProps,
    dispatchProps,
    null,
    { areStatesEqual }
)(CGradeChart);

export default GradeChart;